export default __webpack_public_path__ + "static/media/orologio.ac4ea5bd.svg";